/**
 * @voltxampere/ui — Opto-isolated UART (PC817) variant (Sprint 49-7)
 *
 * Galvanic isolation between two UART nodes via PC817 (Sharp /
 * generic) optocouplers. Slow speed (~10 kbaud max with bare PC817,
 * up to 115200 with high-speed variants like 6N137). Used in
 * industrial RS-485 / serial bus protection.
 *
 * Topology:
 *   TX → 220Ω → PC817 LED anode
 *               PC817 phototransistor → 10kΩ pull-up → RX
 *
 * Reference: Sharp PC817 datasheet (1995-2010 reissue).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const icPc817Uart = {
    id: "pc817-uart",
    nameTr: "PC817 Opto-İzole UART",
    nameEn: "PC817 Opto-Isolated UART",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "PC817-UART",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5.0,
        busType: "isolated-uart",
        isolationVoltageV: 5000,
        maxBaudRate: 9600,
        ledCurrentLimitOhm: 220,
        pullupKohm: 10,
        propagationDelayUs: 4,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=ic-pc817-uart.js.map